import { Checkbox, DefaultButton, PrimaryButton, TextField, ChoiceGroup } from "@fluentui/react";
import React, { useCallback } from "react";
import { t } from "i18next";
import MobileInput from "../../../../components/MobileInput";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";

const UserDetailsSection = (props) => {

  const setMobileError = (e) => {
    if(e == null){
      props.setCustomMobileError(null);
    }
    props.setCustomMobileError(e);
  }

  const handleInputValidationMobile = (inputNumber,country) => {
    let targetLength = country.format.match(/\./g).length;
    let fixedLength = targetLength - country.dialCode.length;
    let inputTargetLength =
      inputNumber.length - country.dialCode.length;
      console.log("--- Mobile Field Values ---",inputNumber,targetLength,fixedLength,inputTargetLength,country);
    if (
      inputTargetLength != fixedLength &&
      inputNumber.length > country.dialCode.length &&
      !(inputNumber.length >= 10 && fixedLength > 10)
    ) {
        console.log("--- Error in validation mobile field ---");
        props.setCustomMobileError("For " + country.name + " (" + fixedLength + " digits required)");
        return;
    }
    if (
      (inputTargetLength == 0 || inputNumber.length < 2 )
    ) {
        console.log("---- Error mobile field empty ----");
          setTimeout(()=>{
            props.setCustomMobileError("Mobile cannot be blank");
          },100);     
        return;
    }
      console.log("---- No error in mobile field -----");
      setTimeout(()=>{
        props.setCustomMobileError(null);
      },100);
  }
 
  return (
    <>
      {(props.state.action === ACTIONS.ADD || props.state.action === ACTIONS.EDIT) &&
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("user.user-details")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">

            <div className="ms-Grid-row">
              <TextField
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                name="firstName"
                placeholder={t("user.first-name")}
                label={t("user.first-name")}
                onChange={props.handleChange}
                value={props.values.firstName}
                onBlur={props.handleBlur}
                errorMessage={props.touched.firstName && props.errors.firstName}
              />

              <TextField
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                name="lastName"
                placeholder={t("user.last-name")}
                label={t("user.last-name")}
                onChange={props.handleChange}
                value={props.values.lastName}
                onBlur={props.handleBlur}
                errorMessage={props.touched.lastName && props.errors.lastName}
              />
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <TextField
                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                name="email"
                placeholder={t("user.email")}
                label={t("user.email")}
                onChange={props.handleChange}
                value={props.values.email}
                onBlur={props.handleBlur}
                errorMessage={props.touched.email && props.errors.email}
              />
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <MobileInput
                  name={`mobile`}
                  value={props.values.mobile}
                  label={t("user.mobile")}
                  onChangeCustom={(value, data) => {
                    handleInputValidationMobile(value,data);
                    const event = { target: { name: "mobile", value: "+" + value } };
                    props.handleChange(event);
                    props.values.mobile = "+" + value;
                  }}
                  touched={props.touched.mobile}
                  errorMessage={setMobileError}
                />
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <TextField
                className={
                  "form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                }
                name="username"
                placeholder={t("user.username")}
                label={t("user.username")}
                autoComplete="off"
                onChange={props.handleChange}
                value={props.values.username}
                onBlur={props.handleBlur}
                errorMessage={props.touched.username && props.errors.username}
                readOnly={props.state.action === ACTIONS.EDIT}
              />

            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              {/* PASSWORD NOT TO BE SHOWN ON EDIT PAGE */}
              {props.state.action === ACTIONS.ADD && (
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  name="password"
                  placeholder={t("user.password")}
                  type="password"
                  label={t("user.password")}
                  autoComplete="off"
                  canRevealPassword
                  onChange={props.handleChange}
                  value={props.values.password}
                  onBlur={props.handleBlur}
                  errorMessage={
                    props.touched.password && props.errors.password
                  }
                />
              )}
              {/* CONFIRM PASSWORD NOT TO BE SHOWN ON EDIT PAGE */}
              {props.state.action === ACTIONS.ADD && (
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  name="confirmPassword"
                  placeholder={t("user.confirm-password")}
                  type="password"
                  label={t("user.confirm-password")}
                  autoComplete="off"
                  canRevealPassword
                  onChange={props.handleChange}
                  value={props.values.confirmPassword}
                  onBlur={props.handleBlur}
                  errorMessage={
                    props.touched.confirmPassword &&
                    props.errors.confirmPassword
                  }
                />
              )}
            </div>
          </div>
        </div>
      }
      {props.state.action === ACTIONS.VIEW &&
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("user.user-details")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.first-name")}</div>
                <div className="form-mt-10">{props.values.firstName}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.last-name")}</div>
                <div className="form-mt-10">{props.values.lastName}</div>
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.email")}</div>
                <div className="form-mt-10">{props.values.email}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("user.mobile")}</div>
                <div className="form-mt-10">{props.values.mobile}</div>
              </div> 
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div className="form-heading">{t("user.username")}</div>
                <div className="form-mt-10">{props.values.username}</div>
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                {process.env.REACT_APP_ENTERPRISE_PLATFORM === "false" &&
                    <div className="form-heading">{props.userType === USERTYPES.FIRMADMIN ? t("user.firm-code"):t("user.code")}</div>
                }
                {process.env.REACT_APP_ENTERPRISE_PLATFORM === "true" &&
                    <div className="form-heading">{props.userType === USERTYPES.FIRMADMIN ? t("user.hospital-code"):t("user.code")}</div>
                }
                <div className="form-mt-10">{props.userType === USERTYPES.FIRMADMIN ? props.values.firmCode:props.values.code }</div>
              </div>
            </div>
            {(props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN) && 
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                  <div className="form-heading">{process.env.REACT_APP_ENTERPRISE_PLATFORM === "false"? t("user.firm"):t("user.hospital")}</div>
                  <div className="form-mt-10">{props.values.firmName}</div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </>
  )
};

export default UserDetailsSection;